import { Component } from '@angular/core';
import { onboards } from './shared/models/onboards.model';
import { CommonService } from './shared/services/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'console';
  constructor(private service: CommonService) {}

  selectedSection: string = ['apps', 'security'].includes(
    window.location.pathname.split('/').pop(),
  )
    ? window.location.pathname.split('/').pop()
    : 'apps';

  events: onboards;
  onboards: onboards;
  isRequest: boolean = true;
  loading: boolean = false;

  changeSelectedSection(section): void {
    this.selectedSection = '';
    setTimeout(() => {
      this.selectedSection = section;
    }, 100);
  }
  /** To do user section postponed commented to prevent eslint notification
  getUser(): void {
    const url = 'cross/user';
    this.service.get(url).subscribe(
      (data: jsonResponseApi) => {},
      (error) => {},
    );
  }
  */
}
